import ModalQueueController from '@/controllers/ModalQueueController'

export default ModalQueueController()
